import { useCallback, useEffect, useState } from 'react';

export default function useAnnouncement() {
  const [announcement, setAnnouncement] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const load = useCallback(() => {
    setLoading(true);
    setError(null);
    return fetch('/.netlify/functions/announcement-public')
      .then((r) => {
        if (!r.ok) throw new Error('Failed to load announcement');
        return r.json();
      })
      .then((data) => setAnnouncement(data.announcement || null))
      .catch((err) => setError(err))
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  return { announcement, loading, error, reload: load };
}
